<!--suppress JSValidateTypes -->
<template>
    <div class="bg-gray-700">
        <div id="loader" class="center-viewport"></div>
        <transition name="fade" mode="out-in">
            <navbar-component :key="navbarElementKey"/>
        </transition>
        <transition name="fade" mode="out-in"
                    v-on:after-enter="beforeEnter"
                    v-on:leave="leave">
            <router-view :key="mainElementKey"/>
        </transition>
        <transition name="fade" mode="out-in">
            <footer-component :key="footerElementKey"/>
        </transition>
    </div>
</template>

<script>
    import NavbarComponent from "./components/Navbar.vue";
    import FooterComponent from "./components/Footer.vue";
    import {mapGetters} from 'vuex';

    export default {
        name: "App",
        components: {
            NavbarComponent,
            FooterComponent,
        },
        methods: {
            // Used for the transition, to hide the loading icon
            beforeEnter() {
                const element = document.getElementById('loader');
                element.classList.remove('lds-dual-ring');
            },
            leave() {
                const element = document.getElementById('loader');
                element.classList.add('lds-dual-ring');
                window.scrollTo(0,0);
            },
        },
        computed: {
            navbarElementKey: function () {
                return `${this.getCurrentLocale}-nav`;
            },
            mainElementKey: function () {
                return `${this.getCurrentLocale}-main`;
            },
            footerElementKey: function () {
                return `${this.getCurrentLocale}-footer`;
            },
            ...mapGetters(['getText', 'getCurrentLocale']),
        },
    }
</script>

<!--suppress CssUnusedSymbol -->
<style>
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.8s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

    .lds-dual-ring {
        display: inline-block;
        width: 80px;
        height: 80px;
    }

    /*noinspection ALL*/
    .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 64px;
        height: 64px;
        margin: 8px;
        border-radius: 50%;
        border: 6px solid #fff;
        border-color: #fff transparent #fff transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }

    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .center-viewport {
        position: absolute;
        z-index: 0;
        top: 50%;
        left: 50%;
        margin-right: -50%;
        transform: translate(-50%, -50%)
    }
</style>